import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { SocialProof } from '../components/SocialProof';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { LiveNotifications } from '../components/LiveNotifications';
export function LandingPage() {
  return <main className="min-h-screen bg-cream font-sans text-warmgray selection:bg-terracotta selection:text-white overflow-x-hidden" data-id="element-260">
      <HeroSection data-id="element-261" />
      <ProblemSection data-id="element-262" />
      <FailedApproaches data-id="element-263" />
      <MechanismSection data-id="element-264" />
      <WhatYouGet data-id="element-265" />
      <AudienceSection data-id="element-266" />
      <HowItWorks data-id="element-267" />
      <ProofSection data-id="element-268" />
      <SocialProof data-id="element-269" />
      <FAQSection data-id="element-270" />
      <PricingSection data-id="element-271" />
      <Footer data-id="element-272" />
      <LiveNotifications data-id="element-273" />
    </main>;
}